import { Switch, Box, Flex, Progress, Text, Checkbox } from "@chakra-ui/react";
import { useForm } from "react-hook-form";

import PrimaryButton from "components/Button/PrimaryButton";
import CardDefault from "ui/components/Cards/CardDefault";
import Field from "ui/components/Input/Field";
import { useState, useEffect } from "react";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import { ConfiguracaoWhiteLabelForm } from "core/features/configuracao-whitelabel/typings/index";
import useConfiguracaoWhiteLabel from "../../../../../../../core/features/configuracao-whitelabel/hooks/useConfiguracaoWhiteLabel";
import useSaveConfiguracaoWhiteLabel from "../../../../../../../core/features/configuracao-whitelabel/hooks/useSaveConfiguracaoWhiteLabel";
import { Row } from "antd";
import { Col } from "antd";
import UploadImagem from "components/Input/UploadImagem";

export default function ConfiguracaoWhiteLabel({
  tenantId,
}: {
  tenantId: string;
}) {
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const { data, isLoading } = useConfiguracaoWhiteLabel(tenantId);
  const { mutate: handleSave, isLoading: isLoadingSave } =
    useSaveConfiguracaoWhiteLabel(tenantId);

  const { handleSubmit, control, watch, reset } =
    useForm<ConfiguracaoWhiteLabelForm>({
      defaultValues: {},
    });

  useEffect(() => {
    if (data) {
      reset(data);
    }
  }, [data, reset]);

  const onSubmit = (data: ConfiguracaoWhiteLabelForm) => {
    handleSave(data, {
      onSuccess: () => {
        showSuccess();
      },
      onError: (error) => {
        showErrorAxios(error);
      },
    });
  };

  const ativo = watch("ativo");

  return (
    <CardDefault>
      {isLoading ? (
        <Progress
          size="sm"
          isIndeterminate
          w="100%"
          my={4}
          colorScheme="cyan"
        />
      ) : (
        <>
          <Text fontSize="18px" fontWeight="bold" mb={4}>
            Configurações White Label
          </Text>

          <Field
            name="ativo"
            control={control}
            shouldUnregister
            render={({ field }) => (
              <Switch
                d="flex"
                alignItems="center"
                size="lg"
                onChange={() => {
                  field.onChange(!field.value);
                }}
                isChecked={!!field.value}
              >
                Ativar White Label
              </Switch>
            )}
          />

          {ativo ? (
            <>
              <Box as={Col} sm={6} mt={4}>
                <Field
                  control={control}
                  name="mostrarEmpresasFilhas"
                  render={({ field }) => (
                    <Checkbox
                      isChecked={field.value}
                      onChange={() => field.onChange(!field.value)}
                    >
                      <Text fontSize="14px">Mostrar nas empresas filhas</Text>
                    </Checkbox>
                  )}
                />
              </Box>

              <Box as={Col} sm={6} mt={4}>
                <Field
                  name="corPrimaria"
                  control={control}
                  shouldUnregister
                  label="Cor primária"
                  inputProps={{
                    type: "color",
                  }}
                />
              </Box>

              <Box as={Row} gap={4} mt={4}>
                <Box as={Col} sm={6}>
                  <Field
                    control={control}
                    name="logoUrl"
                    label="Logo"
                    render={({ field }) => {
                      return (
                        <UploadImagem
                          {...field}
                          isTenant
                          confirmButton="Enviar logotipo"
                          onUploadChange={setUploadingLogo}
                        />
                      );
                    }}
                  />
                </Box>
              </Box>
            </>
          ) : null}

          <Flex mt={8} justifyContent="right">
            <PrimaryButton
              isLoading={isLoadingSave || uploadingLogo}
              isDisabled={isLoadingSave || uploadingLogo}
              onClick={handleSubmit(onSubmit)}
            >
              Salvar
            </PrimaryButton>
          </Flex>
        </>
      )}
    </CardDefault>
  );
}
